<div class="border-1 surface-border border-round p-4">
  <em-coverage-card i18n-title title="Assurance cancer">
    <p-dropdown
      [options]="coverageAmountOptions"
      [filter]="true"
      [virtualScroll]="true"
      [virtualScrollItemSize]="30"
      filterBy="value"
      filterMatchMode="startsWith"
      [formControl]="form.controls.coverageAmount"
      optionLabel="name"
      optionValue="value"></p-dropdown>
  </em-coverage-card>
</div>
